import type {ValidateMessages} from "rc-field-form/lib/interface";

export const formValidateMessages: ValidateMessages = {
  required: "",
};
